import { render } from "./ClientReports.vue?vue&type=template&id=d762dfbe&scoped=true"
import script from "./ClientReports.vue?vue&type=script&lang=js"
export * from "./ClientReports.vue?vue&type=script&lang=js"

import "./ClientReports.vue?vue&type=style&index=0&id=d762dfbe&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d762dfbe"]])

export default __exports__